import { EventColorPalette } from "@/config";
import { BLUE, MINT, SALMON, VIOLET } from "@/config/mui/colorPalette";
import { VisitStatus } from "@/types";

export const getColorForStatus = (status: VisitStatus) =>
  ({
    [VisitStatus.SCHEDULED]: BLUE[80],
    [VisitStatus.CONFIRMED]: VIOLET[80],
    [VisitStatus.COMPLETED]: MINT[80],
    [VisitStatus.CANCELLED]: SALMON[80],
    [VisitStatus.CANCELLED_LATE]: SALMON[80],
    [VisitStatus.NO_SHOW]: SALMON[80],
  })[status];

export const getIconColors = (
  status: VisitStatus,
  eventColorPalette: EventColorPalette,
  iconColors?: string,
  visitIconColors?: string
) => {
  const fallbackColor = getColorForStatus(status);

  const deprecatedColors =
    status === VisitStatus.COMPLETED
      ? "currentColor"
      : eventColorPalette?.[80] ?? fallbackColor;

  return {
    iconColor: iconColors || deprecatedColors,
    visitIconColor: visitIconColors || deprecatedColors,
  };
};
